{
  "title": "Reports",
  "subtitle": "Pick a question on the left. Every report can be filtered and exported to Excel.",
  "subtitleMobile": "Pick a question. Every report can be filtered and exported to Excel.",
  "back": "Reports",
  "export": "Export to Excel",
  "groups": {
    "sales": "Sales",
    "suppliers": "Suppliers",
    "now": "Stock right now",
    "moved": "What moved",
    "trends": "Trends"
  },
  "items": {
    "stock-status": {
      "title": "Stock status",
      "question": "What do I have, and what is low or out?",
      "description": "Every active product with its quantity, its limits and its state."
    },
    "valuation": {
      "title": "Valuation",
      "question": "How much is my stock worth?",
      "description": "Stock value at weighted average cost, by location, by category and by product."
    },
    "negative": {
      "title": "Negative stock",
      "question": "Where is the system below zero?",
      "description": "Every product and place below zero, with the document that confirmed it."
    },
    "stock-at": {
      "title": "Stock on a past date",
      "question": "What did I have on a given day?",
      "description": "The stock at the end of the chosen day, rebuilt from the movements."
    },
    "movements": {
      "title": "Movements by period",
      "question": "What came in and went out, and who did it?",
      "description": "Stock in and out by product, by type of operation and by person."
    },
    "adjustments": {
      "title": "Adjustments and losses",
      "question": "What was damaged, lost or found?",
      "description": "Corrections by reason and by product, with what they added and removed."
    },
    "transfers": {
      "title": "Transfers",
      "question": "What moved between locations, and is anything late?",
      "description": "Transfers of the period, their state, their delay and what was lost on the way."
    },
    "counts": {
      "title": "Count differences",
      "question": "How far were counts from the system?",
      "description": "Validated counts and their differences. Open the lines of a count to see what differed."
    },
    "movers": {
      "title": "Top movers and dead stock",
      "question": "What sells most, and what never moves?",
      "description_one": "What sells the most, and what has not moved for {{count}} day or more.",
      "description_other": "What sells the most, and what has not moved for {{count}} days or more."
    },
    "user-activity": {
      "title": "User activity",
      "question": "Who did how much, and when?",
      "description": "The actions of each person over the period."
    },
    "sales": {
      "title": "Sales",
      "question": "How much did we sell, where and through whom?",
      "description": "Sales by day, location, channel, register and cashier, tax included: a sale counts the day its goods were handed over, a return the day it came back. By pricing mode: retail and wholesale sales apart, with their discounts."
    },
    "sales-products": {
      "title": "Sales by product",
      "question": "What sold, and how much of it came back?",
      "description": "Quantities sold and returned, their average price, their discounts and what they brought, tax included, per product or per product with variants; under a product sold at wholesale, its wholesale part."
    },
    "payments": {
      "title": "Payments",
      "question": "How was the money taken, and what do couriers still owe?",
      "description": "Payments and refunds by method and by register, counted as the Z reports do; courier settlements and the cash on delivery still out."
    },
    "tax": {
      "title": "VAT",
      "question": "How much VAT for the declaration?",
      "description": "VAT by month and rate, as the invoices and receipts split it, returns and refunds taken off; the documents issued and the stamp duty."
    },
    "z-reports": {
      "title": "Z reports",
      "question": "What did each till close with?",
      "description": "The Z reports of the period: what each shift took, the cash expected and counted, the variance."
    },
    "margins": {
      "title": "Margins",
      "question": "What did we earn on the goods?",
      "description": "Sales without VAT, their cost when they left the stock and the margin, per product and per category. Shipping is left out."
    },
    "purchases": {
      "title": "Purchases",
      "question": "What did we receive from suppliers, and what is still to pay?",
      "description": "The receipts of the period with their amount to pay, what completed payments paid and what is still open; by supplier."
    },
    "supplier-payments": {
      "title": "Supplier payments",
      "question": "What did we pay suppliers, and how?",
      "description": "Payments made in the period, on the day they were paid, and those scheduled to their due date; by method and by supplier. Cancelled payments are left out."
    },
    "supplier-balances": {
      "title": "Supplier balances",
      "question": "What do we owe each supplier today?",
      "description": "For each supplier: the amount to pay of its receipts, what is paid, scheduled and advanced, and the balance; then every receipt not fully paid, oldest first."
    },
    "day": {
      "title": "Day report",
      "question": "How did the day go?",
      "description": "One day of the company or of one location: the sales hour by hour, the money received, the drawers, what to check, the best sellers and customers, the orders, the stock that moved and the suppliers paid. Its figures are those of the other reports for that day."
    },
    "promotions": {
      "title": "Promotions",
      "question": "What did each promotion sell and give?",
      "description": "For each promotion, the tickets, the pieces, what it took off, the sales and the margin, net of what came back."
    }
  },
  "filters": {
    "period": "Period",
    "location": "Location",
    "category": "Category",
    "state": "State",
    "date": "Date",
    "type": "Type",
    "reason": "Reason",
    "status": "Status",
    "all": "All",
    "from": "From",
    "to": "To",
    "allCategories": "All",
    "variants": "Variants",
    "variantsEach": "One line each",
    "variantsProduct": "Grouped by product",
    "channel": "Channel",
    "register": "Register",
    "supplier": "Supplier",
    "receiptStatus": "Payment",
    "method": "Method",
    "day": "Day",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "today": "Today",
    "allDates": "All dates"
  },
  "periods": {
    "today": "Today",
    "yesterday": "Yesterday",
    "7d": "Last 7 days",
    "30d": "Last 30 days",
    "90d": "Last 90 days",
    "month": "This month",
    "lastMonth": "Last month",
    "year": "This year",
    "day": "A day…",
    "custom": "Custom dates"
  },
  "range": "{{from}} – {{to}}",
  "sections": {
    "products": "Products",
    "bySite": "By location",
    "byCategory": "By category",
    "pairs": "Below zero",
    "types": "By operation type",
    "people": "By person",
    "reasons": "By reason",
    "transfers": "Transfers",
    "counts": "Counts",
    "lines": "Lines that differ",
    "top": "Top {{count}} by value issued",
    "topQuantity": "Top {{count}} issued",
    "dead": "Dead stock",
    "byDay": "By day",
    "byChannel": "By channel",
    "byRegister": "At the tills, by register",
    "byCashier": "At the tills, by cashier",
    "byMethod": "By payment method",
    "settlements": "Courier settlements",
    "byCarrier": "By courier",
    "codPending": "Cash on delivery still out",
    "byRate": "By month and rate",
    "documents": "Documents issued",
    "zReports": "Z reports",
    "receipts": "Receipts",
    "bySupplier": "By supplier",
    "payments": "Payments",
    "balances": "Balances",
    "openReceipts": "Receipts not fully paid",
    "byPricingMode": "By pricing mode",
    "byHour": "Sales by hour",
    "shifts": "Shifts and drawers",
    "exceptions": "To check",
    "topProducts": "Best sellers",
    "topCustomers": "Best customers",
    "orderFlow": "Online and back-office orders",
    "stockTypes": "Stock moved, by operation",
    "operations": "Stock operations validated",
    "adjustmentReasons": "Adjustments by reason",
    "supplierPayments": "Supplier payments",
    "supplierDue": "Supplier payments due tomorrow",
    "promotions": "Promotions"
  },
  "columns": {
    "sku": "SKU",
    "product": "Product",
    "category": "Category",
    "quantity": "Quantity",
    "min": "Min",
    "max": "Max",
    "state": "State",
    "value": "Value (TND)",
    "lastMovement": "Last movement",
    "site": "Location",
    "share": "Share",
    "products": "Products",
    "averageCost": "Average cost (TND)",
    "location": "Location",
    "document": "Document",
    "confirmedBy": "Confirmed by",
    "in": "In",
    "out": "Out",
    "net": "Net",
    "inValue": "In (TND)",
    "outValue": "Out (TND)",
    "lines": "Lines",
    "operationType": "Operation",
    "operations": "Operations",
    "person": "Person",
    "reason": "Reason",
    "adjustments": "Adjustments",
    "addedValue": "Added (TND)",
    "removedValue": "Removed (TND)",
    "added": "Added",
    "removed": "Removed",
    "number": "Number",
    "from": "From",
    "to": "To",
    "status": "Status",
    "sent": "Sent",
    "received": "Received",
    "days": "Days",
    "lostLines": "Lines lost",
    "lossValue": "Lost (TND)",
    "validated": "Validated",
    "different": "Lines that differ",
    "percent": "Difference",
    "expected": "Expected",
    "counted": "Counted",
    "difference": "Difference",
    "actions": "Actions",
    "receipts": "Receipts",
    "issues": "Issues",
    "transfers": "Transfers",
    "counts": "Counts",
    "signIns": "Sign-ins",
    "last": "Last action",
    "variants": "Variants",
    "day": "Day",
    "orders": "Orders",
    "sales": "Sales",
    "returns": "Returns",
    "allowances": "Refunds without return",
    "tax": "VAT",
    "channel": "Channel",
    "channelType": "Type",
    "register": "Register",
    "cashier": "Cashier",
    "sold": "Sold",
    "returned": "Returned",
    "salesExclTax": "Sales excl. VAT",
    "cost": "Cost",
    "margin": "Margin",
    "marginPercent": "Margin %",
    "method": "Method",
    "count": "Count",
    "refunded": "Refunded",
    "date": "Date",
    "carrier": "Courier",
    "handedIn": "Handed in",
    "outOrders": "Orders still out",
    "stillOut": "Still out",
    "reference": "Reference",
    "total": "Total",
    "customer": "Customer",
    "shipped": "Shipped",
    "due": "Due",
    "month": "Month",
    "rate": "Rate",
    "gross": "Incl. VAT",
    "documentType": "Document",
    "stampDuty": "Stamp duty",
    "closed": "Closed",
    "variance": "Variance",
    "approvedBy": "Approved by",
    "supplier": "Supplier",
    "theirReference": "Their reference",
    "goodsValue": "Goods value",
    "amountDue": "Amount to pay",
    "paid": "Paid",
    "open": "Still to pay",
    "receiptStatus": "Payment",
    "payments": "Payments",
    "paymentStatus": "Status",
    "amount": "Amount",
    "scheduled": "Scheduled",
    "advance": "Advance",
    "balance": "Balance",
    "openReceipts": "Open receipts",
    "oldestOpen": "Oldest open",
    "age": "Age",
    "pricingMode": "Prices",
    "units": "Quantity sold",
    "beforeDiscounts": "Before discounts",
    "discounts": "Discounts",
    "averagePrice": "Average price",
    "hour": "Hour",
    "opened": "Opened",
    "shiftStatus": "Status",
    "float": "Float",
    "time": "Time",
    "dayEvent": "What",
    "where": "Where",
    "detail": "Detail",
    "orderEvent": "Step",
    "online": "Online",
    "backOffice": "Back office",
    "partner": "From / to",
    "discountPercent": "Discount %",
    "promotion": "Promotion",
    "tickets": "Tickets"
  },
  "codes": {
    "stockState": {
      "in_stock": "In stock",
      "low": "Low",
      "out": "Out",
      "negative": "Negative",
      "overstock": "Overstock"
    },
    "transferStatus": {
      "draft": "Draft",
      "sent": "Sent",
      "partially_received": "Partly received",
      "received": "Received",
      "cancelled": "Cancelled"
    },
    "operationType": {
      "stockIn": "Stock in",
      "stockOut": "Stock out",
      "adjustment": "Adjustment",
      "openingStock": "Opening stock",
      "transfer": "Transfer",
      "order": "Sales and orders"
    },
    "paymentMethod": {
      "cash": "Cash",
      "card": "Card",
      "cheque": "Cheque",
      "transfer": "Bank transfer",
      "cashOnDelivery": "Cash on delivery",
      "payAtPickup": "Pay at pickup",
      "online": "Online"
    },
    "channelType": {
      "pos": "Counter",
      "online": "Online store",
      "backOffice": "Back office"
    },
    "documentType": {
      "receipt": "Receipts",
      "invoice": "Invoices",
      "creditNote": "Credit notes"
    },
    "receiptStatus": {
      "unpaid": "Unpaid",
      "partlyPaid": "Partly paid",
      "paid": "Paid"
    },
    "paymentStatus": {
      "pending": "Scheduled",
      "completed": "Paid",
      "cancelled": "Cancelled"
    },
    "pricingMode": {
      "retail": "Retail",
      "wholesale": "Wholesale"
    },
    "shiftStatus": {
      "open": "Open",
      "pendingApproval": "Waiting for a manager",
      "closed": "Closed"
    },
    "dayEvent": {
      "saleCancelled": "Sale cancelled at the till",
      "paymentVoided": "Payment voided",
      "refundWithoutReceipt": "Refund without a receipt",
      "lateReturn": "Return past its period",
      "largeDiscount": "Discount above the limit",
      "cashVariance": "Cash variance, approved",
      "cashVariancePending": "Cash variance, waiting for a manager",
      "drawerOpened": "Drawer opened without a sale",
      "approvalDiscount": "Approval: large discount",
      "approvalVoid": "Approval: cancel or correct",
      "approvalRefund": "Approval: refund without a receipt",
      "approvalLateReturn": "Approval: late return"
    },
    "orderEvent": {
      "placed": "Placed",
      "shipped": "Shipped",
      "collected": "Collected",
      "handedOver": "Handed over",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "returned": "Brought back"
    }
  },
  "summary": {
    "products_one": "{{value}} product",
    "products_other": "{{value}} products",
    "value": "{{value}} TND",
    "low": "{{value}} low",
    "out": "{{value}} out",
    "negative": "{{value}} negative",
    "overstock": "{{value}} overstock",
    "pairs_one": "{{value}} place below zero",
    "pairs_other": "{{value}} places below zero",
    "lines_one": "{{value}} movement line",
    "lines_other": "{{value}} movement lines",
    "inValue": "In {{value}} TND",
    "outValue": "Out {{value}} TND",
    "adjustments_one": "{{value}} adjustment",
    "adjustments_other": "{{value}} adjustments",
    "losses": "Removed {{value}} TND",
    "net": "Net {{value}} TND",
    "transfers_one": "{{value}} transfer",
    "transfers_other": "{{value}} transfers",
    "inTransit": "{{value}} in transit",
    "late": "{{value}} late",
    "lossValue": "Lost {{value}} TND",
    "counts_one": "{{value}} count",
    "counts_other": "{{value}} counts",
    "overLimit": "{{value}} above the limit",
    "dead_one": "{{value}} dead item",
    "dead_other": "{{value}} dead items",
    "deadValue": "Dead stock {{value}} TND",
    "people_one": "{{value}} person",
    "people_other": "{{value}} people",
    "actions_one": "{{value}} action",
    "actions_other": "{{value}} actions",
    "orders_one": "{{value}} sale",
    "orders_other": "{{value}} sales",
    "sales": "Sold {{value}} TND",
    "returns": "Returns {{value}} TND",
    "allowances": "Refunds without return {{value}} TND",
    "tax": "VAT {{value}} TND",
    "discounts": "Discounts given {{value}} TND",
    "averageTicket": "Average ticket {{value}} TND",
    "received": "Received {{value}} TND",
    "refunded": "Refunded {{value}} TND",
    "settled": "Settled by couriers {{value}} TND",
    "pending": "Still out {{value}} TND",
    "pendingOrders_one": "{{value}} delivery not settled",
    "pendingOrders_other": "{{value}} deliveries not settled",
    "lateOrders_one": "{{value}} late",
    "lateOrders_other": "{{value}} late",
    "gross": "Incl. VAT {{value}} TND",
    "stampDuty": "Stamp duty {{value}} TND",
    "salesExclTax": "Sales excl. VAT {{value}} TND",
    "cost": "Cost {{value}} TND",
    "margin": "Margin {{value}} TND",
    "marginPercent": "Margin {{value}} %",
    "withoutCost_one": "{{value}} product without a cost",
    "withoutCost_other": "{{value}} products without a cost",
    "zReports_one": "{{value}} Z report",
    "zReports_other": "{{value}} Z reports",
    "variance": "Variance {{value}} TND",
    "receipts_one": "{{value}} receipt",
    "receipts_other": "{{value}} receipts",
    "amountDue": "To pay {{value}} TND",
    "paid": "Paid {{value}} TND",
    "open": "Still to pay {{value}} TND",
    "payments_one": "{{value}} payment",
    "payments_other": "{{value}} payments",
    "scheduled": "Scheduled {{value}} TND",
    "owed": "Owed to suppliers {{value}} TND",
    "suppliersOwed_one": "{{value}} supplier to pay",
    "suppliersOwed_other": "{{value}} suppliers to pay",
    "openReceipts_one": "{{value}} receipt not fully paid",
    "openReceipts_other": "{{value}} receipts not fully paid",
    "wholesaleSales": "Wholesale {{value}} TND",
    "promotionCount_one": "{{value}} promotion",
    "promotionCount_other": "{{value}} promotions",
    "promotions": "Promotions {{value}} TND",
    "handDiscounts": "Hand discounts {{value}} TND"
  },
  "days_one": "{{count}} day",
  "days_other": "{{count}} days",
  "total": "Total",
  "showLines": "Lines",
  "hideLines": "Hide lines",
  "issued": "{{quantity}} issued",
  "empty": "Nothing to show for these filters.",
  "truncated": "Only the first {{count}} rows are shown and exported. Narrow the filters to see the rest.",
  "costsHidden": "Values are hidden: they need the \"see costs\" permission.",
  "teaser": {
    "title": "Top issued · last 30 days",
    "dead_one": "Dead stock: {{count}} item · {{value}} TND",
    "dead_other": "Dead stock: {{count}} items · {{value}} TND",
    "open": "Open"
  },
  "dayFigures": {
    "net": "Net sales",
    "orders": "Sales",
    "units": "Quantity sold",
    "received": "Money received",
    "margin": "Margin",
    "tax": "VAT",
    "toCheck": "To check",
    "lastWeek": "Last {{weekday}}: {{value}} TND",
    "lastWeekSoFar": "Same time last {{weekday}}: {{value}} TND",
    "noComparison": "No sales last {{weekday}}",
    "averageTicket": "Average ticket {{value}} TND",
    "discounts": "Discounts given {{value}} TND",
    "returns": "Returns and refunds {{value}} TND",
    "marginPercent": "{{value}} % of sales excl. VAT",
    "netExclTax": "Sales excl. VAT {{value}} TND",
    "nothingToCheck": "Nothing to check",
    "openShifts_one": "{{count}} shift still open",
    "openShifts_other": "{{count}} shifts still open",
    "allClosed": "Every shift is closed",
    "newCustomers_one": "{{count}} new customer",
    "newCustomers_other": "{{count}} new customers"
  }
}
